// src/components/Contact/GroupSizeField.js
import React from 'react';
import { SelectField } from '@aws-amplify/ui-react';

const GroupSizeField = ({ value, onChange }) => (
  <div className="form-field grid-field">
    <label className="amplify-label">Group Size</label>
    <SelectField
      label=""
      labelHidden
      value={value}
      onChange={onChange}
      required
    >
      {[...Array(4)].map((_, i) => (
        <option key={i} value={i + 1}>{i + 1}</option>
      ))}
    </SelectField>
  </div>
);

export default GroupSizeField;
